import { DateTime } from 'luxon';

export const getDefaultDisplayMonth = (timezone: string = 'Europe/London'): DateTime => {
  const now = DateTime.now().setZone(timezone);
  const dayOfMonth = now.day;
  
  // If before the 10th, show previous month
  if (dayOfMonth < 10) {
    return now.minus({ months: 1 });
  }
  
  // Otherwise show current month
  return now.startOf('month');
};